import axios, { AxiosResponse } from 'axios';

import {
    YmGenerationsAccountsRequest,
    YmGenerationsAccountsResponse,
    YmGenerationsDictionariesResponse,
    YmGenerationsListRequest,
    YmGenerationsListResponse
} from '../../../../pages/settings/yandexMetrics/types/generations';
import { axiosConfigAuth } from '../middleware';
import {
    API_YM_GENERATIONS_ACCOUNTS,
    API_YM_GENERATIONS_DICTIONARIES,
    API_YM_GENERATIONS_LIST
} from '../urls';

export const ymGenerationsApi = {
    // Список сгенерированных конверсий (серверная пагинация/сортировка/фильтрация)
    getList: async (
        payload: YmGenerationsListRequest
    ): Promise<AxiosResponse<YmGenerationsListResponse>> =>
        axios.post(API_YM_GENERATIONS_LIST, payload, axiosConfigAuth()),

    // Справочники задач и статусов выгрузки (запрашивать один раз при открытии)
    getDictionaries: async (): Promise<AxiosResponse<YmGenerationsDictionariesResponse>> =>
        axios.get(API_YM_GENERATIONS_DICTIONARIES, axiosConfigAuth()),

    // Lazy-поиск аккаунтов для фильтра
    getAccounts: async (
        payload: YmGenerationsAccountsRequest
    ): Promise<AxiosResponse<YmGenerationsAccountsResponse>> =>
        axios.post(API_YM_GENERATIONS_ACCOUNTS, payload, axiosConfigAuth())
};
